import {} from '../types/addressTypes.types';
export const getMailingAddressFields = (physicalAddress, mailingAddress) => Object.keys(physicalAddress).reduce((previousIteration, currentKey) => ({
    ...previousIteration,
    [currentKey]: mailingAddress[currentKey] ? mailingAddress[currentKey] : physicalAddress[currentKey],
}), {});
